import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SchoolOnboardingSchema } from '../pages/OnBoardingPage/School/schema'

type OnboardingState = Partial<SchoolOnboardingSchema>

const initialState: OnboardingState = {}

const schoolOnboardingSlice = createSlice({
    name: 'schoolOnboarding',
    initialState,
    reducers: {
        setData: (
            state,
            action: PayloadAction<Partial<SchoolOnboardingSchema>>
        ) => {
            Object.assign(state, action.payload)
        },
        resetSchoolOnboarding: () => initialState,
    },
})

export const { setData, resetSchoolOnboarding } = schoolOnboardingSlice.actions
export default schoolOnboardingSlice.reducer
